import clsx from 'clsx'
import React, { FC, MutableRefObject, useState } from 'react'

import SvgWarning from '@Assets/SVG/Warning'
import { NativeModal, NativeModalActions } from '@Components/Modal/NativeModal/NativeModal'
import GiftCardMessageInput from '@Components/Product/GiftCardDisplay/giftCardMessageInput'
import { Button } from '@CoreComponents/Buttons/Button'
import { useTranslation } from '@Globals/Translations'

import styles from './GiftCardTextPrompt.module.scss'

export interface GiftCardTextPromptProps {
  onClose: () => void
  onSubmit: (text: string) => void
}

export const GiftCardTextPrompt: FC<GiftCardTextPromptProps> = ({ onClose, onSubmit }) => {
  const { t } = useTranslation()
  const [giftCardText, setGiftCardText] = useState('')

  return (
    <div className={clsx(styles.giftCardTextPrompt, styles.giftcard)}>
      <SvgWarning />
      <h1 className={styles.title}>{t('giftcard:GIFT_CARD_ERROR_NO_MESSAGE_HEADER')}</h1>
      <p>
        {t(
          'giftcard:GIFT_CARD_ERROR_NO_MESSAGE_CONTENT',
          'Please remember to add an amount so the lucky one receiving a Trendhim gift card feels very special!',
        )}
      </p>
      <GiftCardMessageInput
        message={giftCardText}
        onchange={setGiftCardText}
        placeholder={t('giftcard:GIFT_CARD_MESSAGE_PLACEHOLDER', 'Your message goes here')}
      />
      <span className={styles.buttons}>
        <Button
          className={styles.newButton}
          onClick={() => onSubmit(giftCardText)}
          theme="black"
        >
          {t('cms:ADD_TO_CART')}
        </Button>
        <Button
          className={styles.newButton}
          onClick={() => { onClose() }}
          theme="white"
        >
          {t('common:CLOSE')}
        </Button>
      </span>
    </div>
  )
}

interface GiftCardTextPromptModalProps extends GiftCardTextPromptProps{
  actionRef?: MutableRefObject<NativeModalActions | null>
  backdrop?: boolean
  defaultOpen?: boolean
}

export const GiftCardTextPromptModal: FC<GiftCardTextPromptModalProps> = ({
  actionRef,
  backdrop = true,
  defaultOpen,
  onClose,
  onSubmit,
}) => (
  <NativeModal
    actionRef={actionRef}
    backdrop={backdrop}
    className={styles.dialog}
    closeOnBackDrop={false}
    closeOnEscape={false}
    defaultOpen={defaultOpen}
    onClose={onClose}
  >
    <GiftCardTextPrompt
      onClose={onClose}
      onSubmit={onSubmit}
    />
  </NativeModal>
)
